import React, { useState, useRef } from "react";
import "./Gallery.css";

export default function Event() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const gridRef = useRef(null);

  const events = [
    { title: "Annual Function", img: "/images/gallery/annual_function.jpg" },
    { title: "Launched UKSC", img: "/images/gallery/launched_uksc.jpg" },
    { title: "Uttarbanga Medha Ratna Utsav", img: "/images/gallery/uttarbanga_medha_ratna_utsav.jpg" },
    { title: "Manchester City Football School", img: "/images/gallery/manchester_city_football_school.jpg" },
    { title: "Gitanjali Indian", img: "/images/gallery/gitanjali_indian.jpg" },
    { title: "Poush Mela", img: "/images/gallery/poush_mela.jpg" },
    { title: "Inaugural session of the 6th globalised education forum", img: "/images/gallery/inaugural_session_of_the_6th_globalised_education_forum.jpg" },
    { title: "Ms Shreya Basak Secured 1st place in the asian open taekwondo championship", img: "/images/gallery/ms_shreya_basak_secured_1st_place_in_the_asian_open_taekwondo_championship.jpg" },
    { title: "Inauguration of the new teresa block of tigps hooghly", img: "/images/gallery/inauguration_of_the_new_teresa_block_of_tigps_hooghly.jpg" }
  ];

  const getGridPosition = (index) => {
    const col = index % 3;
    const row = Math.floor(index / 3);
    return { col, row };
  };

  const handleMouseMove = (e) => {
    if (!gridRef.current) return;

    const rect = gridRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const col = Math.floor((x / rect.width) * 3);
    const row = Math.floor((y / rect.height) * 3);

    const index = row * 3 + col;

    if (index >= 0 && index < 9) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <section>
      <div className="container-custom">

        <div className="media-top">
          <h2>Gallery</h2>

          <a href="/gallery" className="learn-more">
            <i className="bi bi-arrow-right-circle-fill"></i>
            Learn more
          </a>
        </div>

        <div className="row gallery-container">
          <div className="col">

            <div
              ref={gridRef}
              className="grid-container"
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
            >

              {/* Grid lines */}
              <div className={`grid-lines ${hoveredIndex !== null ? "hide-lines" : ""}`}>
                {[...Array(9)].map((_, i) => (
                  <div key={i} className="grid-line-cell"></div>
                ))}
              </div>

              {/* Grid items */}
              {events.map((event, index) => {
                const { col, row } = getGridPosition(index);
                const isHovered = hoveredIndex === index;

                return (
                  <div
                    key={index}
                    className="grid-item"
                    style={{
                      left: isHovered ? "0%" : `${col * 33.333}%`,
                      top: isHovered ? "0%" : `${row * 33.333}%`,
                      width: isHovered ? "100%" : "33.333%",
                      height: isHovered ? "100%" : "33.333%",
                      zIndex: isHovered ? 10 : 1
                    }}
                  >

                    <div className="grid-item-content">

                      <img
                        src={event.img}
                        alt={event.title}
                        className="grid-item-img"
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />

                      <div className="gradient-overlay"></div>

                      <div
                        className="item-title"
                        style={{
                          left: isHovered ? `${col * 33.333}%` : "0%",
                          bottom: isHovered ? `${(2 - row) * 33.333}%` : "0%",
                          width: isHovered ? "33.333%" : "100%",
                          opacity: isHovered ? 0 : 1
                        }}
                      >
                        <h3>{event.title}</h3>
                      </div>

                    </div>

                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}